import useEntity from 'core/hooks/useEntity'

const useCase = (...args) => useEntity('cases', ...args)
export default useCase
